import { Enums } from "./Enums";

export class EnumMap
{
  names:string[];
  keys:number[];
  
  get size(){ return this.names.length; }

  namesToKeys = new Map<string,number>();
  keysToNames = new Map<number,string>();

  static create( enumObject:any )
  {
    let map = new EnumMap();
    
    let names = Enums.getNames( enumObject );

    map.names = names;
    map.keys = [];

    for ( let i = 0; i < map.names.length; i++ )
    {
      let name = map.names[ i ];
      let key  = enumObject[ name ];

      map.keys.push( key );
      map.namesToKeys.set( name, key );
      map.keysToNames.set( key, name );
    }
    
    return map;
  }
}

